/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_CiInputs */

const en_rd_fix_ci = /** @type {(inputs: Rd_Fix_CiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a GitHub Actions workflow that runs the tests on every push.`)
};

const id_rd_fix_ci = /** @type {(inputs: Rd_Fix_CiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan workflow GitHub Actions yang menjalankan tes di tiap push.`)
};

/**
* | output |
* | --- |
* | "Add a GitHub Actions workflow that runs the tests on every push." |
*
* @param {Rd_Fix_CiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_ci = /** @type {((inputs?: Rd_Fix_CiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_CiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_ci(inputs)
	return en_rd_fix_ci(inputs)
});